
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mavonEditor } from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import {
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Drawer,
} from 'element-ui';
import api from '@/api/helpQues';
import publicApi from '@/api/public';
import otherQues from './otherQues.vue';

@Component({
  components: {
    mavonEditor,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Drawer,
    otherQues,
  },
})

export default class HomeIndex extends Vue {
  @Prop({
    required: false,
  }) oldForm!: any;

  private form: any = {};

  private types: any = [];

  private saveMaterialLoading: boolean = false;

  private previewUrl: string = '';

  private drawer: boolean = false;

  public $refs!:{
    md: any,
  }

  mounted() {
    publicApi.getType('manage_help_manual').then((res: any) => {
      this.types = res;
    });
    if (this.$route.params.pid) {
      api.getMualById(Base64.decode(this.$route.params.pid)).then((res: any) => {
        const oldForm:any = res;
        this.form = {
          helpTitle: oldForm.helpTitle,
          helpType: String(oldForm.helpType),
          sort: oldForm.sort,
          pid: oldForm.pid,
          helpContent: oldForm.helpContent,
        };
        this.previewUrl = `//help.manage.coding4fun.com.cn/detail/${oldForm.pid}/${oldForm.helpTitle}/${oldForm.helpType}/${oldForm.helpTypeLabel}`;
      });
    }
  }

  imgAdd(pos: any, file: any) {
    const formData = new FormData();
    formData.append('image', file);
    publicApi.addImage(formData).then((res: any) => {
      this.$refs.md.$img2Url(pos, res);
    });
  }

  save() {
    this.handleSaveMaterial();
  }

  doPreview() {
    if (this.previewUrl) window.open(this.previewUrl);
  }

  handleSaveMaterial() {
    this.saveMaterialLoading = true;
    if (this.form.pid) {
      api.editHelpManual(this.form).then((res: any) => {
        this.saveMaterialLoading = false;
      });
    } else {
      api.addHelpManual(this.form).then((res: any) => {
        this.saveMaterialLoading = false;
      });
    }
  }
}
